interface Props {
    children: React.ReactNode;
}

export const ListGroupItemActions = ({ children }: Props): React.ReactElement<any, any> | null => {
    return <div className="ml-auto d-flex align-items-center">{children}</div>;
};
